export const setOrderStatus = (status: string) => {
  switch (status) {
    case 'В роботі':
      return 'Р';

    case 'Готовий до оплати':
      return 'О';

    case 'Новий':
      return 'Н';

    case 'Готовий до відвантаження':
      return 'О';

    case 'Збір замовлення':
      return 'С';

    default:
      return status?.slice(0, 1);
  }
};
